import { $fsf } from "@2kog/pkg-common/utils/api.js";

// 获取交易日历
/**
 *
 * @param {String} date 锚定月份 格式 YYYY-MM 当月可不传
 * @returns
 */
export function getTradeCalendar(date) {
    const params = date ? { date } : {};
    return $fsf().get("/common/calendar", { params });
}

export function getTradeCalendarFree(date) {
    const params = date ? { date } : {};
    return $fsf().get("/common/calendar/free", { params });
}

// 获取用户配置
export function getUserConfig() {
    return $fsf().get("/common/user/config");
}

// 更新用户配置
export function updateUserConfig(data) {
    return $fsf().put("/common/user/config", data);
}
